export default __webpack_public_path__ + "static/media/sample.3646a1f1.hdr";